// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/planPricing.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9812: ONE Self-Serve price table — monthly + annual — client + server.)
// =============================================================================
export const PLAN_PRICING = Object.freeze({
  "annualEnabled": true,
  "monthlyDollars": 250,
  "annualDollars": 2500,
  "annualSavingsDollars": 500,
  "monthlyLabel": "$250/mo",
  "annualLabel": "$2,500/yr",
  "annualSavingsLabel": "save $500",
  "annualFinePrint": "Billed annually, non-refundable, renews yearly.",
  "monthlyFinePrint": "Billed monthly. Cancel anytime."
});
